export default __webpack_public_path__ + "static/logo-full-1da25cd90851e385671aa4a0f77fa89c.svg";